var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3422 11.4792H28.6623L30.5716 7.81774C30.6194 7.73424 30.6484 7.64139 30.6568 7.54558C30.6652 7.44977 30.6528 7.35328 30.6203 7.26275C30.5879 7.17221 30.5362 7.08978 30.4688 7.02114C30.4015 6.95249 30.32 6.89925 30.2301 6.86509L27.5632 5.84719L27.926 5.11956C27.9767 5.01809 28.0007 4.90534 27.9956 4.79202C27.9905 4.6787 27.9565 4.56857 27.8969 4.47207C27.8373 4.37557 27.754 4.2959 27.6549 4.24063C27.5559 4.18535 27.4443 4.15631 27.3309 4.15625H20.6736C20.5601 4.1562 20.4485 4.18516 20.3494 4.24038C20.2502 4.29561 20.1668 4.37526 20.1071 4.47178C20.0474 4.5683 20.0134 4.67848 20.0083 4.79186C20.0031 4.90523 20.0271 5.01803 20.0778 5.11956L20.4413 5.84719L17.7737 6.86243C17.6835 6.89659 17.6018 6.94996 17.5342 7.01883C17.4667 7.0877 17.4149 7.17043 17.3825 7.2613C17.35 7.35216 17.3378 7.44898 17.3465 7.54506C17.3552 7.64114 17.3846 7.73418 17.4329 7.81774L19.3422 11.4792Z",
    fill: "url(#paint0_linear_10269_5260)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3871 10.8125H18.6178C18.6178 10.8125 10.1562 23.4582 10.1562 31.2401C10.1562 35.599 11.9547 42.9131 24.0025 42.9131C36.0503 42.9131 37.8487 35.599 37.8487 31.2401C37.8487 23.4582 29.3871 10.8125 29.3871 10.8125Z",
    fill: "url(#paint1_linear_10269_5260)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.78125,
    y: 7.56641,
    width: 49.5664,
    height: 46.4336
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_0_10269_5260_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_10269_5260)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3057 13.5664H16.697C16.697 13.5664 5.21875 27.1316 5.21875 35.4795C5.21875 40.1553 7.6584 48.0012 24.0014 48.0012C40.3443 48.0012 42.784 40.1553 42.784 35.4795C42.784 27.1316 31.3057 13.5664 31.3057 13.5664Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3057 13.5664H16.697C16.697 13.5664 5.21875 27.1316 5.21875 35.4795C5.21875 40.1553 7.6584 48.0012 24.0014 48.0012C40.3443 48.0012 42.784 40.1553 42.784 35.4795C42.784 27.1316 31.3057 13.5664 31.3057 13.5664Z",
    fill: "url(#paint2_linear_10269_5260)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7669 13.7164H31.2358C31.2566 13.7413 31.2845 13.7748 31.3191 13.8165C31.4029 13.9175 31.5258 14.0669 31.6824 14.26C31.9955 14.6464 32.443 15.2078 32.9802 15.9077C34.0546 17.3077 35.4869 19.2609 36.9189 21.474C38.3512 23.6875 39.7815 26.1585 40.8532 28.5942C41.926 31.0324 42.634 33.423 42.634 35.4795C42.634 37.7926 42.0308 40.8773 39.4174 43.3855C36.8028 45.8948 32.1512 47.8512 24.0014 47.8512C15.8515 47.8512 11.1999 45.8948 8.58531 43.3855C5.97188 40.8773 5.36875 37.7926 5.36875 35.4795C5.36875 33.423 6.07671 31.0324 7.14953 28.5942C8.22126 26.1585 9.65151 23.6875 11.0838 21.474C12.5158 19.2609 13.9481 17.3077 15.0225 15.9077C15.5597 15.2078 16.0072 14.6464 16.3203 14.26C16.4769 14.0669 16.5998 13.9175 16.6836 13.8165C16.7182 13.7748 16.7461 13.7413 16.7669 13.7164Z",
    stroke: "url(#paint3_linear_10269_5260)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.5625,
    y: -6,
    width: 32.8711,
    height: 23.4766
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_1_10269_5260_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10269_5260)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6949 11.4783H31.3036L34.2963 5.73913C34.3711 5.60825 34.4166 5.46271 34.4298 5.31254C34.443 5.16236 34.4235 5.01112 34.3726 4.86921C34.3217 4.7273 34.2407 4.5981 34.1351 4.4905C34.0295 4.38291 33.9019 4.29946 33.761 4.24591L29.5808 2.65043L30.1495 1.50991C30.229 1.35087 30.2665 1.17415 30.2585 0.996528C30.2505 0.818909 30.1972 0.646279 30.1038 0.49502C30.0103 0.343761 29.8798 0.21889 29.7245 0.132255C29.5692 0.0456199 29.3944 9.5038e-05 29.2166 1.13375e-07H18.7818C18.6039 -8.27997e-05 18.429 0.0453122 18.2736 0.131874C18.1182 0.218435 17.9875 0.343289 17.8939 0.494577C17.8003 0.645864 17.747 0.818562 17.7389 0.996268C17.7309 1.17397 17.7684 1.35079 17.8479 1.50991L18.4177 2.65043L14.2364 4.24174C14.095 4.29529 13.9669 4.37894 13.8611 4.48689C13.7552 4.59484 13.674 4.72452 13.6232 4.86694C13.5724 5.00936 13.5531 5.16112 13.5668 5.31172C13.5804 5.46232 13.6266 5.60816 13.7022 5.73913L16.6949 11.4783Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6949 11.4783H31.3036L34.2963 5.73913C34.3711 5.60825 34.4166 5.46271 34.4298 5.31254C34.443 5.16236 34.4235 5.01112 34.3726 4.86921C34.3217 4.7273 34.2407 4.5981 34.1351 4.4905C34.0295 4.38291 33.9019 4.29946 33.761 4.24591L29.5808 2.65043L30.1495 1.50991C30.229 1.35087 30.2665 1.17415 30.2585 0.996528C30.2505 0.818909 30.1972 0.646279 30.1038 0.49502C30.0103 0.343761 29.8798 0.21889 29.7245 0.132255C29.5692 0.0456199 29.3944 9.5038e-05 29.2166 1.13375e-07H18.7818C18.6039 -8.27997e-05 18.429 0.0453122 18.2736 0.131874C18.1182 0.218435 17.9875 0.343289 17.8939 0.494577C17.8003 0.645864 17.747 0.818562 17.7389 0.996268C17.7309 1.17397 17.7684 1.35079 17.8479 1.50991L18.4177 2.65043L14.2364 4.24174C14.095 4.29529 13.9669 4.37894 13.8611 4.48689C13.7552 4.59484 13.674 4.72452 13.6232 4.86694C13.5724 5.00936 13.5531 5.16112 13.5668 5.31172C13.5804 5.46232 13.6266 5.60816 13.7022 5.73913L16.6949 11.4783Z",
    fill: "url(#paint4_linear_10269_5260)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1659 5.66464L34.1633 5.66978L31.2126 11.3283H16.7858L13.8352 5.66978L13.8353 5.66971L13.8321 5.66416C13.7674 5.55201 13.7278 5.42714 13.7161 5.29819C13.7045 5.16924 13.7209 5.03929 13.7645 4.91734C13.808 4.7954 13.8775 4.68436 13.9681 4.59193C14.0588 4.49949 14.1685 4.42787 14.2896 4.38202L14.2898 4.38193L18.471 2.79063L18.6259 2.73167L18.5518 2.5834L17.9821 1.44288L17.9821 1.44286C17.914 1.30661 17.8819 1.15522 17.8888 1.00305C17.8957 0.850893 17.9414 0.703021 18.0215 0.573481C18.1016 0.443941 18.2135 0.337035 18.3466 0.262917C18.4796 0.188799 18.6294 0.149929 18.7818 0.15H18.7818H29.2166C29.3688 0.15009 29.5185 0.189071 29.6514 0.263243C29.7844 0.337424 29.8962 0.444346 29.9762 0.573861C30.0562 0.703377 30.1018 0.851191 30.1086 1.00328C30.1155 1.15536 30.0834 1.30668 30.0153 1.44286L30.0153 1.44298L29.4466 2.5835L29.3727 2.73157L29.5273 2.79057L33.7075 4.38605L33.7077 4.38613C33.8284 4.43198 33.9376 4.50343 34.0281 4.59556C34.1185 4.6877 34.1878 4.79832 34.2314 4.91983C34.2749 5.04134 34.2917 5.17084 34.2804 5.29943C34.2691 5.42802 34.2301 5.55263 34.166 5.6647L34.1659 5.66464Z",
    stroke: "url(#paint5_linear_10269_5260)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_10269_5260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.03 31.0914C28.0915 30.2174 26.9706 29.5627 25.7483 29.1746L24.7997 28.8125V24.2702C26.136 24.3816 27.448 24.6929 28.6919 25.1937L29.6039 22.9106C28.0781 22.2847 26.4523 21.938 24.8039 21.8869V19.8281H23.1396V21.9213C21.8197 21.9993 20.5531 22.4694 19.502 23.2716C19.0742 23.6071 18.7301 24.0373 18.4969 24.5284C18.2637 25.0194 18.1476 25.558 18.158 26.1015C18.126 27.0872 18.4606 28.0498 19.0971 28.8031C19.9271 29.6612 20.9525 30.3056 22.0856 30.6813L23.1291 31.0674V35.7349C22.2611 35.7111 21.3988 35.5875 20.559 35.3666C19.6958 35.1618 18.8564 34.8669 18.0547 34.4869V37.1186C19.6656 37.7751 21.3929 38.0981 23.1323 38.0681V40.6977H24.7924V37.993C26.1843 37.9168 27.5183 37.4108 28.6105 36.5447C29.0377 36.1765 29.378 35.7182 29.6066 35.2026C29.8352 34.6871 29.9466 34.1272 29.9326 33.5634C29.9586 32.6544 29.6356 31.7699 29.03 31.0914ZM23.1396 28.1979C22.5462 27.9981 22.0003 27.6784 21.5357 27.2587C21.2384 26.937 21.0795 26.5112 21.0933 26.0733C21.089 25.8552 21.1337 25.6389 21.224 25.4402C21.3142 25.2416 21.4479 25.0657 21.615 24.9255C22.0532 24.5803 22.5812 24.3681 23.1364 24.314L23.1396 28.1979ZM24.7997 35.6347V31.6549C25.4144 31.8487 25.9876 32.1552 26.4902 32.5586C26.6551 32.7092 26.7855 32.8937 26.8727 33.0993C26.9598 33.3049 27.0016 33.527 26.9952 33.7502C26.9966 34.7812 26.2648 35.4093 24.7997 35.6347Z",
    fill: "white",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.6953,
    y: 5.47656,
    width: 26.6094,
    height: 14.0859
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_2_10269_5260_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_10269_5260)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.304 11.4766H16.6953V13.5635H31.304V11.4766Z",
    fill: "url(#paint6_linear_10269_5260)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.4609,
    y: -3.35156,
    width: 16.1719,
    height: 17.7031
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_3_10269_5260_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_10269_5260)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5159 6.83592L18.4216 2.64844L16.4609 3.39452L18.6522 7.76878C18.7128 7.89245 18.7973 8.0029 18.9008 8.09376C19.0043 8.18462 19.1247 8.2541 19.2552 8.29819C19.3857 8.34228 19.5236 8.3601 19.661 8.35064C19.7984 8.34117 19.9325 8.30461 20.0557 8.24305C20.1789 8.18148 20.2887 8.09615 20.3787 7.99195C20.4688 7.88776 20.5373 7.76677 20.5804 7.63596C20.6235 7.50516 20.6402 7.36712 20.6297 7.2298C20.6192 7.09249 20.5815 6.95862 20.519 6.83592H20.5159Z",
    fill: "url(#paint7_linear_10269_5260)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 21.3711,
    y: -3.35156,
    width: 16.1719,
    height: 17.7031
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_4_10269_5260_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_10269_5260)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4879 6.83592L29.5822 2.64844L31.5429 3.39452L29.3516 7.76878C29.291 7.89245 29.2065 8.0029 29.103 8.09376C28.9995 8.18462 28.8791 8.2541 28.7486 8.29819C28.6182 8.34228 28.4803 8.3601 28.3429 8.35064C28.2055 8.34117 28.0713 8.30461 27.9481 8.24305C27.8249 8.18148 27.7151 8.09615 27.6251 7.99195C27.535 7.88776 27.4665 7.76677 27.4234 7.63596C27.3804 7.50516 27.3636 7.36712 27.3742 7.2298C27.3847 7.09249 27.4223 6.95862 27.4848 6.83592H27.4879Z",
    fill: "url(#paint8_linear_10269_5260)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_10269_5260",
    x: -0.78125,
    y: 7.56641,
    width: 49.5664,
    height: 46.4336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10269_5260"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_10269_5260_clip_path",
    transform: "translate(0.78125 -7.56641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3057 13.5664H16.697C16.697 13.5664 5.21875 27.1316 5.21875 35.4795C5.21875 40.1553 7.6584 48.0012 24.0014 48.0012C40.3443 48.0012 42.784 40.1553 42.784 35.4795C42.784 27.1316 31.3057 13.5664 31.3057 13.5664Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10269_5260",
    x: 7.5625,
    y: -6,
    width: 32.8711,
    height: 23.4766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10269_5260"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_10269_5260_clip_path",
    transform: "translate(-7.5625 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6949 11.4783H31.3036L34.2963 5.73913C34.3711 5.60825 34.4166 5.46271 34.4298 5.31254C34.443 5.16236 34.4235 5.01112 34.3726 4.86921C34.3217 4.7273 34.2407 4.5981 34.1351 4.4905C34.0295 4.38291 33.9019 4.29946 33.761 4.24591L29.5808 2.65043L30.1495 1.50991C30.229 1.35087 30.2665 1.17415 30.2585 0.996528C30.2505 0.818909 30.1972 0.646279 30.1038 0.49502C30.0103 0.343761 29.8798 0.21889 29.7245 0.132255C29.5692 0.0456199 29.3944 9.5038e-05 29.2166 1.13375e-07H18.7818C18.6039 -8.27997e-05 18.429 0.0453122 18.2736 0.131874C18.1182 0.218435 17.9875 0.343289 17.8939 0.494577C17.8003 0.645864 17.747 0.818562 17.7389 0.996268C17.7309 1.17397 17.7684 1.35079 17.8479 1.50991L18.4177 2.65043L14.2364 4.24174C14.095 4.29529 13.9669 4.37894 13.8611 4.48689C13.7552 4.59484 13.674 4.72452 13.6232 4.86694C13.5724 5.00936 13.5531 5.16112 13.5668 5.31172C13.5804 5.46232 13.6266 5.60816 13.7022 5.73913L16.6949 11.4783Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_10269_5260",
    x: 18.0547,
    y: 19.8281,
    width: 11.8789,
    height: 22.8711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10269_5260"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_10269_5260",
    x: 10.6953,
    y: 5.47656,
    width: 26.6094,
    height: 14.0859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10269_5260"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_10269_5260_clip_path",
    transform: "translate(-10.6953 -5.47656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.304 11.4766H16.6953V13.5635H31.304V11.4766Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_10269_5260",
    x: 10.4609,
    y: -3.35156,
    width: 16.1719,
    height: 17.7031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10269_5260"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_10269_5260_clip_path",
    transform: "translate(-10.4609 3.35156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5159 6.83592L18.4216 2.64844L16.4609 3.39452L18.6522 7.76878C18.7128 7.89245 18.7973 8.0029 18.9008 8.09376C19.0043 8.18462 19.1247 8.2541 19.2552 8.29819C19.3857 8.34228 19.5236 8.3601 19.661 8.35064C19.7984 8.34117 19.9325 8.30461 20.0557 8.24305C20.1789 8.18148 20.2887 8.09615 20.3787 7.99195C20.4688 7.88776 20.5373 7.76677 20.5804 7.63596C20.6235 7.50516 20.6402 7.36712 20.6297 7.2298C20.6192 7.09249 20.5815 6.95862 20.519 6.83592H20.5159Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_10269_5260",
    x: 21.3711,
    y: -3.35156,
    width: 16.1719,
    height: 17.7031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10269_5260"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_10269_5260_clip_path",
    transform: "translate(-21.3711 3.35156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4879 6.83592L29.5822 2.64844L31.5429 3.39452L29.3516 7.76878C29.291 7.89245 29.2065 8.0029 29.103 8.09376C28.9995 8.18462 28.8791 8.2541 28.7486 8.29819C28.6182 8.34228 28.4803 8.3601 28.3429 8.35064C28.2055 8.34117 28.0713 8.30461 27.9481 8.24305C27.8249 8.18148 27.7151 8.09615 27.6251 7.99195C27.535 7.88776 27.4665 7.76677 27.4234 7.63596C27.3804 7.50516 27.3636 7.36712 27.3742 7.2298C27.3847 7.09249 27.4223 6.95862 27.4848 6.83592H27.4879Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10269_5260",
    x1: 17.3438,
    y1: 4.15625,
    x2: 31.1066,
    y2: 10.5107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10269_5260",
    x1: 10.1563,
    y1: 10.8125,
    x2: 43.2905,
    y2: 18.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10269_5260",
    x1: 5.21875,
    y1: 13.5664,
    x2: 48.9658,
    y2: 25.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10269_5260",
    x1: 6.39266,
    y1: 15.1316,
    x2: 42.784,
    y2: 15.1316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10269_5260",
    x1: 13.5625,
    y1: 0,
    x2: 35.1348,
    y2: 9.96009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10269_5260",
    x1: 14.2147,
    y1: 0.521739,
    x2: 34.4338,
    y2: 0.521739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10269_5260",
    x1: 16.6953,
    y1: 11.4766,
    x2: 21.0995,
    y2: 19.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10269_5260",
    x1: 16.4609,
    y1: 2.64844,
    x2: 21.5177,
    y2: 3.58743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10269_5260",
    x1: 27.3711,
    y1: 2.64844,
    x2: 32.4278,
    y2: 3.58743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.8185d4c3919103bd5dbde4a003a13e44.svg";
export { ForwardRef as ReactComponent };